var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        width: "700px",
        "show-close": false,
        visible: _vm.visible,
        "destroy-on-close": "",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _vm.step == 1
        ? _c(
            "div",
            { staticClass: "import-product-dialog" },
            [
              _c("p", { staticClass: "dialog-head" }, [
                _vm._v("Import orders with Excel")
              ]),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "title-info" },
                [
                  _c("p", { staticStyle: { "margin-top": "30px" } }, [
                    _vm._v(
                      "Download the template and fill in the order information."
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function($event) {
                          return _vm.download()
                        }
                      }
                    },
                    [_vm._v("Order Import Template.xls")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "upload-info" },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        accept: ".xlsx, .xls",
                        headers: _vm.headers,
                        "on-success": _vm.handelSuccess,
                        "on-progress": _vm.handelProgress,
                        "show-file-list": false,
                        drag: "",
                        "before-upload": _vm.handleBeforeUpload,
                        action: _vm.uploadApi
                      }
                    },
                    [
                      _c("i", { staticClass: "el-icon-upload" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "el-upload__text" }, [
                        _vm._v("or drop file to upload，or "),
                        _c("em", [_vm._v("click upload")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip"
                        },
                        [
                          _vm._v(
                            "Supports .xlsx, .xls, format files-the size may not exceed 10M"
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "btn" }, [
                _c("div", { staticClass: "submit" }, [_vm._v("Submit")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "cancel",
                    on: {
                      click: function($event) {
                        _vm.visible = false
                      }
                    }
                  },
                  [_vm._v("Cancel")]
                )
              ])
            ],
            1
          )
        : _vm.step == 2
        ? _c("div", { staticClass: "check-format" }, [
            _c("div", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: true,
                  expression: "true"
                }
              ]
            }),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.isCheckData ? "Validation format" : "Importing product"
                )
              )
            ]),
            _vm._v(" "),
            _vm.isCheckData
              ? _c("div", [
                  _vm._v(
                    "Format validation may take a while uploaded-please do not operate the current page"
                  )
                ])
              : _c("div", [
                  _vm._v(
                    "It may take a while for the product to be uploaded - please do not operate the current page"
                  )
                ])
          ])
        : _vm.step == 3
        ? _c(
            "div",
            { staticClass: "result" },
            [
              _vm.isCheckData
                ? [
                    _c("p", [_vm._v("Template validation format")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Total "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("numberValueFormat")(
                              _vm.uploadCheckObj["orderCount"]
                            )
                          )
                        )
                      ]),
                      _vm._v(" Orders format valid action,\n        "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("numberValueFormat")(
                              _vm.uploadCheckObj["successCount"]
                            )
                          ) + " "
                        )
                      ]),
                      _vm._v(" successful,\n        "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("numberValueFormat")(
                              _vm.uploadCheckObj["failureCount"]
                            )
                          ) + " "
                        )
                      ]),
                      _vm._v(" failed,\n      ")
                    ]),
                    _vm.uploadCheckObj["checkFailureUrl"]
                      ? _c(
                          "p",
                          {
                            staticClass: "submit",
                            on: {
                              click: function($event) {
                                return _vm.download(
                                  _vm.uploadCheckObj["checkFailureUrl"]
                                )
                              }
                            }
                          },
                          [_vm._v("\n        Download failed product data")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "btn" }, [
                      _c(
                        "div",
                        {
                          staticClass: "cancel",
                          on: {
                            click: function($event) {
                              _vm.visible = false
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _vm.uploadCheckObj["checkSuccessUrl"]
                        ? _c(
                            "div",
                            {
                              staticClass: "submit",
                              on: { click: _vm.importOrderData }
                            },
                            [_vm._v("Upload verified orders\n        ")]
                          )
                        : _vm._e()
                    ])
                  ]
                : [
                    _c("p", [_vm._v("Product Import result")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Total\n        "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("numberValueFormat")(
                              _vm.uploadObj["orderCount"]
                            )
                          )
                        )
                      ]),
                      _vm._v(" Orders uploaded,\n        "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("numberValueFormat")(
                              _vm.uploadObj["orderUploadSuccessCount"]
                            )
                          )
                        )
                      ]),
                      _vm._v(" successes,\n        "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("numberValueFormat")(
                              _vm.uploadObj["orderUploadFailureCount"]
                            )
                          )
                        )
                      ]),
                      _vm._v(" failures,\n      ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        on: {
                          click: function($event) {
                            return _vm.download(
                              _vm.uploadObj["uploadResultUrl"]
                            )
                          }
                        }
                      },
                      [_vm._v("Download import result")]
                    ),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "After the goods are approved, they will be displayed on the ShopVidi website"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "btn" }, [
                      _c(
                        "div",
                        {
                          staticClass: "submit",
                          on: {
                            click: function($event) {
                              _vm.visible = false
                            }
                          }
                        },
                        [_vm._v("Ok")]
                      )
                    ])
                  ]
            ],
            2
          )
        : _vm.step == 504
        ? _c("div", { staticClass: "time-out" }, [
            _c("p", [_c("i", { staticClass: "el-icon-warning-outline" })]),
            _vm._v(" "),
            _c("p", [_vm._v("Upload Network Timeout, please re-upload")]),
            _vm._v(" "),
            _c("div", { staticClass: "btn" }, [
              _c(
                "div",
                {
                  staticClass: "submit",
                  on: {
                    click: function($event) {
                      _vm.visible = false
                    }
                  }
                },
                [_vm._v("Ok")]
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b0229d30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0229d30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wholesale/import-orders.vue
// module id = r1Sh
// module chunks = 2